import React from 'react';
import styled from 'styled-components';

const JumpLink = styled.a`
  text-align: right;
  display: block;
  font-size: 0.7rem;
  margin-top: 1rem;
`;

const QuestionJumpLink = () => <JumpLink href="#top">Back to top</JumpLink>

const QUESTIONS = [
  'What can a chiropractor do for me?',
  'Is chiropractic available on the NHS or can I use my medical insurance to pay for treatments?',
  'What happens on my first treatment?',
  'How many treatments will I need?',
  'Does it hurt?',
  'What happens after my first treatment?',
  'How do I know you are a qualified chiropractor?',
];

const QuickNavigation = styled.nav`
  border: 1px solid #ccc;
  margin: 1rem;
  padding: 2rem 3rem;
`;

const QuickNavigationItems = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;

const QuickNavigationItem = styled.li`
  padding-bottom: .5rem;
  display: block;
  &:last-of-type {
    padding-bottom: 0;
  }
`;

const QuickNavigationLink = styled.a`
  display: block;
  width: 100%;
  color: black;

  &:hover {
    display: block;
    background-color: #eee;
    width: 100%;
  }
`;

const Question = styled.section`
  margin-bottom: 1rem;
  max-width: 600px;
  font-size: 1rem;
  margin: 2rem auto;
  padding: 0 16px 16px;
`;

const QuestionHeader = ({ index })=> <h3 id={`q${index}`}>{QUESTIONS[index]}</h3>;

const getNavigationItem = (href, text) => {
  return (
    <QuickNavigationItem key={href}>
      <QuickNavigationLink href={href}>
        {text}
      </QuickNavigationLink>
    </QuickNavigationItem>
  );
}

const getNavigation = () => {

  return (
    <QuickNavigation>
      <QuickNavigationItems>
        {QUESTIONS.map((question, index) => getNavigationItem(`#q${index}`, question))}
      </QuickNavigationItems>
    </QuickNavigation>
  );
}

const getAnswers = () => {
  return (
    <section>
      <Question>
        <QuestionHeader index={0} />
        <p>
          Chiropractic is a healthcare profession that focuses on diagnosis, treatment and
          prevention of mechanical disorders of the musculoskeletal system, with special emphasis
          on the spine. It emphasises manual therapy including spinal manipulation and other joint
          and soft-tissue manipulation, and includes exercises, and health and lifestyle counselling.
        </p>
        <p>Common complaints that can benefit from chiropractic include:</p>
        <ul>
          <li>Ankle sprain (short term management)</li>
          <li>Cramp</li>
          <li>
            Elbow pain and tennis elbow (lateral epicondylitis) arising from associated musculoskeletal
            conditions of the back and neck, but not isolated occurrences
          </li>
          <li>Headache arising from the neck (cervicogenic</li>
          <li>Joint pains</li>
          <li>
            Joint pains including hip and knee pain from osteoarthritis as an adjunct to
            core OA treatments and exercise
          </li>
          <li>General, acute & chronic backache, back pain (not arising from injury or accident)</li>
          <li>Generalised aches and pains</li>
          <li>Lumbago</li>
          <li>Mechanical neck pain (as opposed to neck pain following injury i.e. whiplash)</li>
          <li>Migraine prevention</li>
          <li>Minor sports injuries</li>
          <li>Muscle spasms</li>
          <li>Plantar fasciitis (short term management)</li>
          <li>Rotator cuff injuries, disease or disorders</li>
          <li>Sciatica</li>
          <li>Shoulder complaints (dysfunction, disorders and pain)</li>
          <li>Soft tissue disorders of the shoulder</li>
          <li>Tension and inability to relax</li>
        </ul>
        <p>If you have any questions about an area not covered above please <a href="mailto:ian@bristolchiropractor.co.uk" title="Email Ian Willmott">email</a> or phone on <a href="tel:07908649609">07908 649609</a>.</p>
         <QuestionJumpLink />
      </Question>

      <Question>
        <QuestionHeader index={1} />
        <p>At this time, chiropractic is unfortunately not available on the NHS but watch this space. The use of complementary and alternative medicine (CAM) is on the increase and becoming a more acceptable alternative to pain relief within medical circles. Studies have been carried out suggesting that seeing a chiropractor on the NHS is only a small step away. Many private health insurance companies do accept chiropractic treatment as a valid claim but you should refer to your own policy terms and conditions. </p>
      </Question>

      <Question>
        <QuestionHeader index={2} />
        <p>See the <a href="about/initial-consultation">initial consultation</a> page for more information.</p>
        <QuestionJumpLink />
      </Question>

      <Question>
        <QuestionHeader index={3} />
        <p>The normal recommendation is between 3-6 initially, with the premise to taking
           on maintenance care similar to quarterly or six monthly checks ups that you make
           with your dentist.  The emphasis on this is that prevention is the cure and that
           by leaving a problem until it hurts, becomes very painful or restricts movement
           may be detrimental and result in an extended number of treatments and a longer recovery period.
        </p>
        <p>Of course the number of treatments needed is individual to each patient and depends upon:</p>
        <ul>
          <li>The age of the patient - younger patients tend to respond to treatment quicker.</li>
          <li>The length of time you have had the problem - a recent problem will tend
            to resolve quicker than a well established problem.
          </li>
          <li>The nature of the problem - Simple shoulder pain will tend to resolve
            quicker than frozen shoulder.
          </li>
          <li>Commitment of the patient - often simple exercises will be given to help
              facilitate the process.  If they are carried out, the quicker the problem may resolve.
          </li>
        </ul>
        <QuestionJumpLink />
      </Question>

      <Question>
        <QuestionHeader index={4} />
        <p>The McTimoney treatment is very gentle and rarely painful. Of course pain tolerance
            varies between individuals, but the extremely fast and light adjustments used in
            the McTimoney technique is not uncommonly described as a pleasant sensation.
            These adjustments often leave the new patient wondering if they have actually
            been adjusted at all, however, the treatment is very affective and the results over
            the last 55 years pay testament to this.
        </p>
        <QuestionJumpLink />
      </Question>

      <Question>
        <QuestionHeader index={5} />
          <p>Post treatment reactions vary between patients. Common reactions include:</p>
          <ul>
            <li><strong>Headache</strong> - Opening of joints and relief of muscle tensions can release
                lactic acid into the blood stream.  This increased level can manifest
                as a headache so we recommend you drink plenty of water post treatment
                in order to flush these increase levels out.
            </li>
            <li><strong>Tired</strong> - As previously said, the treatment can be a relaxing
              experience so to feel sleepy post treatment is quite normal.
              Please be aware of this and make time to allow your body to recover
              should you have to drive or operate machinery post treatment.
            </li>
            <li><strong>Menstrual cycle</strong> - Periods may be affected by the treatment.
              Please be aware of this if you are trying to conceive or relying on your
              usual cycle as a means of birth control.  Periods may become, lighter,
              heavier, longer, shorter or less painful.
            </li>
            <li><strong>Flu like symptoms</strong> - It is not uncommon to feel like you are coming
              down with the flu a couple of days after treatment.  If you experience
              aching muscles and joints, this is a good thing as it means your body
              has been affected by the treatment and it is simply adjusting to its
              corrected position.
            </li>
            <li>
              <strong>Feeling better and taller</strong> - Correct alignment of the spine and
              pelvis can leave you feeling taller, more balanced and generally lighter
              on your feet - enjoy this feeling!
            </li>
          </ul>
        <QuestionJumpLink />
      </Question>

      <Question>
        <QuestionHeader index={6} />
          <p>Since 2000, the chiropractic profession is regulated by the General
             Chiropractic Council. It is now a criminal offence to portray, advertise
             or practice as a chiropractor unless you are registered by this council.
         </p>
        <p>McTimoney Chiropractors undertake a 5 year BSc course at the McTimoney
          College of Chiropractic based in Abingdon Oxfordshire. For more information
          about the college or information about becoming a McTimoney Chiropractor
          please see the <a title="The McTimoney College of Chiropractic" target="_blank" href="http://www.mctimoney-college.ac.uk/">college wesbite</a>.
        </p>
        <QuestionJumpLink />
      </Question>

    </section>
  );
}

const Questions = ({ data }) => {

  return (
    <div>
      <h1 id="top">Questions</h1>
      {getNavigation()}
      {getAnswers()}
    </div>
  );
};

export default Questions;

export const query = graphql`
  query QuestionsPageQuery {
    site {
      siteMetadata {
        contactDetails {
          telephoneNumber
          emailAddress
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/questions.js